import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from '../../network/APIEndpoints'
import { sitConfigQrAgentPortal } from '../../network/config'

const getOtpRequestBody = (phoneNumber: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: '91',
      },
    },
    authenticateList: [
      {
        mode: 1,
        value: '',
        action: 'GENERATE',
      },
    ],
    scope: 'SESSION',
    purpose: '3',
  }
}

const responseParser = (data: any) => {
  return data
}

const generateOTP = (mobileNumber: string, tokens: any, reqBody?: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.generateOtp,
    method: 'POST',
    config: sitConfigQrAgentPortal(tokens),
    body: reqBody ? reqBody : getOtpRequestBody(mobileNumber),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { generateOTP }
